import React from 'react';
import { noop } from 'lodash';

export const AccountContext = React.createContext({
    account: {},
    setAccountId: noop,
    isAccountTouched: noop,
    accountConfig: { isReady: false },
    setAccountTouched: noop,
});
